// extracted by mini-css-extract-plugin
module.exports = {"link":"_84ff5fbbc9--link--2618c","accent":"_84ff5fbbc9--accent--1pbvQ","primary":"_84ff5fbbc9--primary--KdquU","light":"_84ff5fbbc9--light--23QAE"};